import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Auth Callback Page
 * Handles Magic Link redirects from email
 * Supabase JS client automatically processes the callback when detectSessionInUrl is true
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { user, isUnlocked } = useAuth();

  useEffect(() => {
    // Give Supabase client a moment to process the callback
    const timer = setTimeout(() => {
      if (user) {
        // User is authenticated, redirect to home
        // If vault is not unlocked, the AuthModal will be shown
        navigate('/');
      } else {
        // No user, redirect to home (error handling)
        navigate('/');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [user, navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#0a0e1a',
      color: '#fff'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginBottom: '20px' }}>
          <div className="spinner" style={{
            border: '4px solid rgba(255, 255, 255, 0.1)',
            borderTop: '4px solid #6366f1',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }} />
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
        <p>Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
